import OfficialslandingModule from './containers/officialslandingModule'

export {default as OfficialslandingModuleLayout} from './components/officialslandingModuleLayout'

export default OfficialslandingModule
